<template>
  <div :class="$style.container">
    <div
      :class="$style.summary"
      v-text="displayAmount"
    ></div>

    <div :class="$style.commission">
      {{ displayComission }}
    </div>

    <div :class="$style.list">
      <payment-system-logo
        v-for="(paymentSystem, idx) in paymentSystems"
        :key="idx"
        :variant="paymentSystem"
      />
    </div>
  </div>
</template>

<script>
import { formatAmount } from 'lib/utils/amount';

import PaymentSystemLogo from 'molecules/common/PaymentSystemLogo';

export default {
  name: 'TransactionInfoCard',
  components: {
    PaymentSystemLogo,
  },
  props: {
    amount: {
      type: Number,
      required: true,
    },
    comission: {
      type: Number,
      default: () => 0,
    },
    currency: {
      type: Object,
      required: true,
    },
    paymentSystems: {
      type: Array,
      required: true,
    },
  },
  computed: {
    displayAmount() {
      return formatAmount(this.amount, this.currency);
    },
    displayComission() {
      if (this.$validate.isPositiveNumber(this.comission)) {
        return `+ ${formatAmount(this.comission, this.currency)} - ${this.$t('comission.of.service')}`;
      }

      return this.$t('comission.none');
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox
    +flex-direction(column)
    +justify-content(space-between)
    width: 100%
    // TODO: вернуть max-width: 340px после рефакторинга контейнера страницы ввода данных карты
    max-width: 360px
    min-height: 160px
    padding: 12px
    border-radius: 5px
    background: linear-gradient(241.39deg, rgba(115, 209, 79, 0.35) -0.37%, rgba(155, 81, 224, 0.35) 96%)

    +respond-to(cramped)
      min-height: 190px
      padding: 15px

  .summary
    +flexbox
    +align-items(center)
    +font-type(medium, 24, 36)
    color: var(--color-grey-1)

  .commission
    +font-type(medium, 12, 15)
    color: var(--color-grey-1)

  .list
    display: grid
    grid-template-columns: repeat(4, 50px)
    grid-column-gap: 5px
    grid-row-gap: 5px
    margin-top: auto

    +respond-to(cramped)
      margin-top: auto
</style>
